<template>
  <footer class="cj-footer" :class="{ game: gameMode }">
    <nav>
      <button class="home" @click="$router.push({ name: 'game-selection' })" />
      <button class="help" @click="modalVisible = true" />
      <div class="joystick" />
      <div class="hatswitch" @click="hatSwitchClicked" />
      <div class="instructions" v-if="gameMode" @click="instructionsClicked" />
      <div class="coins" v-if="!gameMode" @click="coinsClicked" />
    </nav>

    <div class="container">
      <ul class="links">
        <li>
          <a href="https://contact.pepsico.com/FritoLay/privacy-policy">
            PRIVACY POLICY
          </a>
        </li>
        <li>
          <a href="https://contact.pepsico.com/FritoLay/accessibility-statement">
            WEBSITE ACCESSIBILITY STATEMENT
          </a>
        </li>
        <li>
          <a href="https://contact.pepsico.com/FritoLay/about-our-ads">
            ABOUT OUR ADS
          </a>
        </li>
        <li>
          <a href="https://contact.pepsico.com/FritoLay/terms-conditions">
            TERMS OF USE
          </a>
        </li>
        <li>
          <a href="https://contact.pepsico.com/FritoLay/about-us">
            ABOUT US
          </a>
        </li>
      </ul>

      <div class="copyright">
        © 2024 Frito-Lay North America, Inc. a Divison of PepsiCo. All Rights Reserved.
      </div>
    </div>

	<CJModal :show="modalVisible">
      <CJPopup @dismiss="modalVisible = false">
        <div class="bag-box" />
      </CJPopup>
    </CJModal>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

import CJModal from '@/components/CJModal'
import CJPopup from '@/components/CJPopup'

export default {
  name: 'CJFooter',
  components: { CJModal, CJPopup },

  data () {
    return {
      modalVisible: false,
    }
  },
  
  props: {
    gameMode: Boolean,
  },

  computed: {
    ...mapGetters([ 'isDevEnv' ]),
  },

  methods: {
    instructionsClicked () {
      this.$bus.emit('toggle-instructions', false)
    },

    hatSwitchClicked () {
      if (!this.isDevEnv) return

      this.$router.push({ name: 'games-selection' })
    },

    coinsClicked () {
      if (!this.isDevEnv) return

      this.$store.dispatch('resetAll')
    },
  },
}
</script>

<style lang="stylus" scoped>
  footer.cj-footer
    > nav
      position: relative
      display: block
      width: 100%
      height: 133px

      > button.home
        position: absolute
        top: 42px
        left: 37px
        outline: none
        cursor: pointer
        --webkit-tap-highlight-color: transparent

        @media screen and (min-device-width: 1024px)
          top: 46px
          left: 70px

      > button.help
        position: absolute
        top: 42px
        left: 67px
        outline: none
        cursor: pointer
        --webkit-tap-highlight-color: transparent

        @media screen and (min-device-width: 1024px)
          top: 46px
          left: 118px

        @media screen and (max-device-width: 768px)
          left: 81px

      > .joystick
        position: absolute
        top: 13px
        left: 131px

        @media screen and (min-device-width: 1024px)
          top: 14px
          left: 422px

      > .hatswitch
        position: absolute
        top: 42px
        right: 108px

        @media screen and (min-device-width: 1024px)
          top: 43px
          right: 424px

      > .coins
        position: absolute
        top: 49px
        right: 25px

        @media screen and (min-device-width: 1024px)
          top: 49px
          right: 70px

    > .container
      display: flex
      flex-direction: column
      align-items: center
      font-family: 'Helvetica Neue Condensed'

      > ul.links
        display: flex
        justify-content: space-between
        margin: 0 0 10px
        padding: 0
        width: 350px
        list-style: none

        @media screen and (min-device-width: 1024px)
          width: 80%

        @media screen and (max-device-width: 768px)
          width: 90%

        > li > a
          color: white
          text-decoration: none
          font-weight: 700
          font-size: 11pt

      .copyright
        color: #89898b
        text-shadow: 1 1 0 #000
        font-size: 8pt

        @media screen and (max-device-width: 768px)
          margin-top: -6px

    &.game
      > .container > ul.links
        margin: 25px 0 10px

        @media screen and (min-device-width: 1024px)
          margin: -6px 0 10px

      > nav
        > button.home
          top: 52px
          left: 4px

          @media screen and (min-device-width: 1024px)
            top: 42px
            left: 25px

        > button.help
          top: 52px
          left: 49px

          @media screen and (min-device-width: 1024px)
            top: 42px
            left: 70px

          @media screen and (max-device-width: 768px)
            top: 55px
            left: 54px

        > .joystick
          top: 17px
          left: 101px

          @media screen and (min-device-width: 1024px)
            top: 12px
            left: 460px

        > .hatswitch
          top: 52px
          right: 101px

          @media screen and (min-device-width: 1024px)
            top: 41px
            right: 462px

        > .instructions
            position: absolute
            top: 52px
            right: 7px
            cursor: pointer

            @media screen and (min-device-width: 1024px)
              top: 42px
              right: 93px
</style>
